module.exports = __webpack_public_path__ + "media/images/icon-benefits-fitness-e2b43c09eed0a099d24a1503beded8f9.png";